import type { FieldValues } from "react-hook-form";

import { FormElement, type FormElementProps } from "./FormElement";
import { FormProvider, type FormProviderProps } from "./FormProvider";

export type FormProviderAndElementProps<FormValues extends FieldValues> =
  FormElementProps<FormValues> & FormProviderProps<FormValues>;

export const FormProviderAndElement = <FormValues extends FieldValues>({
  children,
  formName,
  formProps,
  onSubmitInvalidData,
  onSubmitValidData,
  watchAll,
}: FormProviderAndElementProps<FormValues>) => {
  return (
    <FormProvider<FormValues> {...{ formName, formProps, watchAll }}>
      <FormElement<FormValues> {...{ onSubmitInvalidData, onSubmitValidData }}>
        {children}
      </FormElement>
    </FormProvider>
  );
};
